import Vue from 'vue';
import App from './App';
import {
	router
} from './router';
import axios from 'axios';
import QS from 'qs'; //用来解决vue中post请求(详情)
// import 'lib-flexible/flexible'

import WechatAuth from 'vue-wechat-auth'
import https from './https'
import {
	getOpenid,
	setOpenid
} from './util/auth'
import {
	createHash
} from './util/hash'
//rem
import "./util/pan"
import 'lib-flexible/flexible';
Vue.prototype.$axios = axios;
Vue.prototype.qs = QS;

import {
	Dialog
} from 'vant';
import { Image as VanImage } from 'vant';
Vue.use(VanImage);


// 微信授权插件初始化
// Vue.use(WechatAuth, {
	
// 	router, // 路由实例对象
// 	appid: 'wxad649039f42e14ca', // 您的微信appid
// 	responseType: 'code', // 返回类型，请填写code
// 	scope: 'snsapi_base', // 应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且，即使在未关注的情况下，只要用户授权，也能获取其信息）
// 	redirect_uri: encodeURIComponent("http://dev.h5.xiaobaikaoyan.com/#/vip"),
// 	getCodeCallback(code, next) {
// 		// 用户同意授权后回调方法
// 		// code：用户同意授权后，获得code值
// 		// code说明： code作为换取access_token的票据，每次用户授权带上的code将不一样，code只能使用一次，5分钟未被使用自动过期。
// 		// next： 无论access_token是否获取成功,一定要调用该方法
// 		// next说明：next方法接收两个参数
// 		// 参数1为通过code值请求后端获取到的access_token值，如果获取失败请填入空字符串''
// 		// 参数2(非必填，默认获取access_token切换到当前路由对象)，指定切换对象 next('/') 或者 next({ path: '/' })
// 		if (getOpenid())
// 			return
// 			axios.get('https://dev.kyyy.xiaobaikaoyan.com/api/mp/getOpenId/wxad649039f42e14ca/' + code, {
// 				})
// 				.then(res => {
// 					console.log(res)
// 					if (res.data && res.data.data) {
// 						console.log(res)
// 						var storage = window.sessionStorage;
// 						storage.setItem('Openid', res.data.data);
// 						next('/')
// 					}
// 				}, err => {
// 					console.log(err)
// 					next('/')
// 				})
// 				.catch((error) => {
// 					console.log(error)
// 				})
				
// 		// https.fetchGet('/api/mp/getOpenId/wxad649039f42e14ca/' + code).then(res => {
// 		// 	if (res.data && res.data.data && res.data.data.access_token) {
// 		// 		setOpenid(res.data.data.openid)
// 		// 		next('/vip')
// 		// 	} 
// 		// }).catch(err => {
// 		// 	console.log(err)
// 		// 	// next('/')
// 		// })
		
		
// 		var storage = window.sessionStorage;
// 		storage.setItem('code', code);
// 		// alert(code)
// 		console.log("code",code)
// 	}
// })



new Vue({
	router,
	el: '#app',
	render: h => h(App)
});
